import { Image } from '../../entities/Media/Media';

export const PAYMENT_METHOD_MASTERCARD: Image = {
    src: '/payment-methods/MasterCard.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/MasterCard.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van MasterCard',
};

export const PAYMENT_METHOD_IDEAL: Image = {
    src: '/payment-methods/iDeal.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/iDeal.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van iDeal',
};

export const PAYMENT_METHOD_GIFTCARD: Image = {
    src: '/payment-methods/Giftcard.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Giftcard.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Giftcard',
};

export const PAYMENT_METHOD_VISA: Image = {
    src: '/payment-methods/Visa.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Visa.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Visa',
};

export const PAYMENT_METHOD_APPLE_PAY: Image = {
    src: '/payment-methods/Apple_Pay.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Apple_Pay.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Apple Pay',
};

export const PAYMENT_METHOD_GOOGLE_PAY: Image = {
    src: '/payment-methods/Google_Pay.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Google_Pay.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Google Pay',
};

export const PAYMENT_METHOD_IN3: Image = {
    src: '/payment-methods/in3.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/in3.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van in3',
};

export const PAYMENT_METHOD_RIVERTY: Image = {
    src: '/payment-methods/Riverty.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Riverty.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Riverty',
};


export const PAYMENT_METHOD_MAESTRO: Image = {
    src: '/payment-methods/Maestro.webp',
    formats: {
        original: {
            srcSet: '/payment-methods/Maestro.webp',
            type: 'image/webp',
            media: '(min-width: 320px)',
        },
    },
    alt: 'Afbeelding van Maestro',
};
